import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  generateRentalInvoiceList: { loading: false, data: null, error: null },
};

export const GenerateRentalInvoiceSlice = createSlice({
  name: "generateRentalInvoice",
  initialState,
  reducers: {
    // generate rental invoice
    fetchgenerateRentalInvoiceListRequest: (state, action) => {
      state.generateRentalInvoiceList.loading = true;
      state.generateRentalInvoiceList.error = null;
    },
    fetchgenerateRentalInvoiceListSuccess: (state, action) => {
      state.generateRentalInvoiceList.data = action.payload;
      state.generateRentalInvoiceList.loading = false;
      state.generateRentalInvoiceList.error = null;
    },
    fetchgenerateRentalInvoiceListFailure: (state, action) => {
      state.generateRentalInvoiceList.data = null;
      state.generateRentalInvoiceList.loading = false;
      state.generateRentalInvoiceList.error = action.payload;
    },
  },
});

export const {
  fetchgenerateRentalInvoiceListRequest,
  fetchgenerateRentalInvoiceListSuccess,
  fetchgenerateRentalInvoiceListFailure,
} = GenerateRentalInvoiceSlice.actions;

export const getGenerateRentalInvoiceListState = (store) =>
  store.generateRentalInvoice?.generateRentalInvoiceList;

export default GenerateRentalInvoiceSlice.reducer;
